import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { tracking } from '../utils/tracking';
import { imgs } from '../assets/imgs';
import { Banner, InfoSection, SpeakerCards, SpeakersForm, } from '../components';
import { useResizeImg } from '../hooks/useResizeImg';

const vidUrl = "https://www.youtube.com/embed/xZotB8v2RmM?&loop=1&rel=0&showinfo=0&color=white&iv_load_policy=3&playlist=xZotB8v2RmM";


export const Speakers = () => {
   document.title = "New England Venture Summit | Speakers";
   const [isLoading, setIsLoading] = useState(true);
   const imageSource = useResizeImg(imgs.speakers.speakersBannerDesktop, imgs.speakers.speakersBannerMobile)

   const scrollRef = useRef(null);

   return (
      <div className='speakers'>
         <Banner imageSource={imageSource} isLoading={isLoading} setIsLoading={setIsLoading} >
            <section>
               <h1> Learn. Engage. Thrive.</h1>
            </section>
            <section>
               <button className="btn" onClick={() => { tracking(287); scrollRef.current.scrollIntoView({ behavior: 'smooth' }) }}>Apply To Speak</button>
               <Link className="btn" to='/agenda' onClick={() => tracking(288)} >Agenda</Link>
            </section>
         </Banner>
         <InfoSection  video={vidUrl}>
            <h1>Informative content & Top-Tier Speakers</h1>
            <span></span>
            <p>As always, we bring together many Investors and thought leaders from across the globe to speak on topics relevant to our current climate curated to help you maximize your potential.</p>
            <p>Our featured Speakers have over a millennia of combined years of experience, and are set to inform you on hot topics in the startup and tech worlds.</p>
            <p>Check out our Featured Speakers below and we can’t wait to see you there!</p>
            <div className='btn-container'>
            <Link className='btn' to='/registration' onClick={() => tracking(289)} >Tickets</Link>
            </div>
         </InfoSection>
         <SpeakerCards />
         <div ref={scrollRef} style={{ scrollMargin: '70px' }} />
         <SpeakersForm />
      </div >
   )
}